import React from 'react';

const UnauthenticatedLayout = (props: any) => {
   return (
      <div
         style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            backgroundColor: '#e2f5f7',
            padding: '1.5rem',
         }}
      >
         {props.children}
      </div>
   );
};

export default UnauthenticatedLayout;
